<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="152 -804 654 654"
    class="icon-download"
  >
    <path
      fill="currentColor"
      d="M479.84-328.83q-6.56 0-12.5-2.49-5.95-2.48-11.45-7.94L302.26-492.89q-10.19-10.47-9.69-24.51.5-14.04 10.3-24.23 10.68-10.23 24.81-10.1 14.12.14 24.32 10.34l93.93 94.69v-325.21q0-14.4 9.88-24.35 9.87-9.96 24.37-9.96 14.49 0 24.19 9.96 9.7 9.95 9.7 24.35v325.21L609-541.39q10-10.2 23.61-9.96 13.62.25 24.23 10.46 10.09 10.22 9.98 24.47-.12 14.25-10.32 24.53L504.11-339.26q-5.52 5.46-11.62 7.94-6.09 2.49-12.65 2.49ZM222.15-154.02q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-108.94q0-14.42 9.87-24.24 9.87-9.82 24.37-9.82 14.5 0 24.2 9.82 9.69 9.82 9.69 24.24v108.94h515.7v-108.94q0-14.42 9.87-24.24 9.87-9.82 24.35-9.82 14.48 0 24.31 9.82 9.84 9.82 9.84 24.24v108.94q0 27.6-20.34 47.86-20.33 20.27-48.03 20.27h-515.7Z"
    />
  </svg>
</template>
